export default "__VITE_ASSET__cyiF3kK6__"